module.exports = __webpack_public_path__ + "media/images/ai-pic-cca43d20.png";